// extracted by mini-css-extract-plugin
export default {"container":"Search_container__Tuk1g","title":"Search_title__tH5gi","search":"Search_search__BpZOP"};